<template>
  <main>
    <p v-if="school === schools['Broadrick']">
      If yes, please check with the school's appointed transport company on service availability prior to enrolment. Kindly submit the
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSdRiODgB7Tdb6wk-WmkKIimIvBgK6GnkSH3RK60Xc_pjTvNkA/viewform" target="_blank">online application form</a>,
      the transport company requires at least 2 weeks notice for all new applications. You may contact Zheng Xing Yun Service at +65 91188261 or email zhengxingyunservice@gmail.com for any enquiries pertaining to school bus service.
    </p>

    <p v-if="school === schools['Orchard']">
      If yes, please check with the school's appointed transport company on service availability prior to enrolment. Kindly download and complete the
      <a href="https://www.etonhouse.edu.sg/wp-content/uploads/2021/04/BUS-FORM.pdf" target="_blank">application form</a>
      and send it directly to the transport company. They require at least 2 weeks notice for all new applications. You may contact Zheng Xing Transit at +65 91188261 or email zhengxingtransit@gmail.com for any enquiries pertaining to school bus service.
    </p>

    <p v-if="school === schools['Sentosa Primary']">
      If yes, please check with the school's appointed transport company on service availability prior to enrolment. Kindly download and complete the
      <a href="https://www.etonhouse.edu.sg/wp-content/uploads/2021/05/Sentosa-School-Bus-Form.docx.pdf" target="_blank">application form</a>
      and send it directly to the transport company. They require at least 2 weeks notice for all new applications. You may contact Yee Giok ransport Service at +65 9894 0222 or email yeegiok_eton@yahoo.com.sg for any enquiries pertaining to school bus service.
    </p>
  </main>
</template>

<script>
import {schools} from "@/pages/application/data";

export default {
  props: ['school'],
  data() {
    return {
      schools,
    }
  },
}
</script>

<style scoped>
p {
  font-style: italic;
}

a {
  color: red;
}
</style>